"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import { useLanguage } from "~/translations/loader/use-language";
export default function SectionIntro() {
  const $ = _c(8);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("mb-5 font-bold text-4xl text-primary sm:text-5xl", "sm:absolute sm:top-[50%] sm:left-12 sm:-translate-x-full sm:translate-y-[-50%] sm:text-right md:left-16", "break-words sm:w-[280px] lg:w-[300px] xl:w-[500px] xl:break-normal");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.jobad_process_hl) {
    t1 = <h2 className={t0} data-source="lc">{t.jobad_process_hl}</h2>;
    $[1] = t.jobad_process_hl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.jobad_process_text) {
    t2 = <p className="text-foreground text-lg" data-source="lc">{t.jobad_process_text}</p>;
    $[3] = t.jobad_process_text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="mb-12 grid sm:grid-cols-3 md:mb-20 lg:mb-28"><div className="relative col-span-2 bg-card p-8 sm:col-start-2 sm:pl-16 md:p-12 md:pl-24">{t1}{t2}</div></div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}